<template>
  <div class="userInfo">
    <div class="header">
      <van-uploader :after-read="data.afterRead">
        <img class="avatar" :src="store.userInfo.avatar" alt="" />
        <div class="renewal">
          <img class="renewalImg" src="@/assets/renewalImg.png" alt="" />
          更换头像
        </div>
      </van-uploader>
    </div>
    <div class="list">
      <div class="item">
        <div class="left">昵称</div>
        <div class="right" @click="data.editName">
          <div class="name">
            {{ store.userInfo.nickname }}
          </div>
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="item">
        <div class="left">手机号</div>
        <div class="right" style="color: #f7f5ff80">
          {{ store.userInfo.phone }}
        </div>
      </div>
      <div class="item">
        <div class="left">登录密码</div>
        <div class="right" @click="data.setPassword">
          <span
            :style="store.userInfo.password !== '' && store.userInfo.password !== null ? 'color: #8368FC;' : ''"
            >{{ store.userInfo.password !== "" && store.userInfo.password !== null ? "已设置" : "未设置" }}</span
          ><van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
  <van-dialog v-model:show="data.editnameDialogFLag" :showConfirmButton="false">
    <div class="editnameDialog">
      <img
        class="close"
        @click="data.editnameDialogFLag = false"
        src="@/assets/close.png"
        alt=""
      />
      <div class="header">修改昵称</div>
      <van-field
        v-model="data.editnameInput"
        maxlength="20"
        show-word-limit
        placeholder="请输入昵称"
      />
      <div class="bottom">
        <div class="btn">取消</div>
        <div class="btn" @click="data.quit">确定</div>
      </div>
    </div>
  </van-dialog>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useRoute, useRouter } from "vue-router";

import { editName, editavatar } from "@/api/login";

import { undateImg } from "@/api/img";

import { showSuccessToast, showFailToast } from "vant";

import cross from "@/assets/cross.png";

import surres from "@/assets/surres.png";

import { useCounterStore } from "@/store";

defineComponent({
  name: "",
});

const store = useCounterStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});

data.editnameInput = "";

data.flag = true;

data.editnameDialogFLag = false;

data.afterRead = (file) => {
  undateImg(file.file).then((res) => {
    editavatar({
      avatar: res.url,
    }).then((res) => {
      if (res.code === 200) {
        store.getUserinfo(store.userInfo.id);
        showSuccessToast({
          message: "修改成功",
          icon: surres,
        });
      }
    });
  });
};

data.quit = () => {
  if (data.editnameInput) {
    if (data.flag) {
      data.flag = false;
      editName({
        nickName: data.editnameInput,
      })
        .then((res) => {
          if (res.code === 200) {
            store.getUserinfo(store.userInfo.id);
            data.editnameDialogFLag = false;
            showSuccessToast({
              message: "修改成功",
              icon: surres,
            });
          }
        })
        .finally(() => {
          data.flag = true;
        });
    }
  } else {
    showFailToast({
      message: "昵称不能为空",
      icon: cross,
    });
  }
};

data.editName = () => {
  data.editnameInput = "";
  data.editnameDialogFLag = true;
};

data.setPassword = () => {
  if (store.userInfo.password) {
    // 修改密码
    router.push({
      name: "editPassword",
    });
  } else {
    // 设置密码
    router.push({
      name: "setPassword",
    });
  }
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.userInfo {
  .header {
    text-align: center;
    margin-top: 72px;
    .avatar {
      width: 168px;
      height: 168px;
      border-radius: 168px;
      background: #2d2e47;
    }
    .renewal {
      position: absolute;
      color: #ffffff;
      font-size: 28px;
      top: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      width: 168px;
      height: 168px;
      border-radius: 168px;
      .renewalImg {
        width: 44px;
        height: 36px;
      }
    }
  }
  .list {
    margin-top: 36px;
    padding: 0 48px;
    color: #f7f5ff;
    .item {
      padding: 28px 0;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-bottom: 1px solid #ffffff20;
      justify-content: space-between;
      .van-icon {
        color: #979797;
      }
      .list {
        flex: 1;
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 30px;
        flex: 1;
        .name {
          text-align: right;
          width: 400px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
::v-deep().van-uploader__input-wrapper {
  position: relative;
}
</style>
<style lang="scss">
.editnameDialog {
  position: relative;
  .close {
    position: absolute;
    right: 30px;
    top: 48px;
    width: 48px;
    height: 48px;
  }
  .header {
    text-align: center;
    padding-top: 42px;
    margin-bottom: 34px;
    font-weight: 500;
    color: #333333;
    font-size: 34px;
  }
  .van-field {
    width: auto;
    background: #eeeeee;
    border-radius: 24px;
    margin: 0 30px;
    padding: 23px 30px;
    .van-cell__value {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .van-field__word-limit {
      font-size: 30px;
      color: #999999;
    }
  }
  .bottom {
    margin-top: 64px;
    margin-bottom: 44px;
    display: flex;
    justify-content: space-between;
    padding: 0 76px;
    font-size: 30px;
    .btn {
      border-radius: 39px;
      padding: 15px 66px;
      border: 2px solid #8368fc;
    }
    .btn:nth-child(1) {
      color: #8368fc;
    }
    .btn:nth-child(2) {
      color: #ffffff;
      background: #8368fc;
    }
  }
}
</style>
